<template>
	<div ref="containerRef"></div>
</template>

<script setup>
	import { onMounted, onUnmounted, ref } from "vue"

	const emits = defineEmits(["token"])
	const containerRef = ref(null)
	let widgetId = null
	let currentToken = ""

	const props = defineProps({
		siteKey: String,
	})

	function loadScript() {
		if (window.turnstile) {
			return Promise.resolve()
		}
		if (window.__grubvisionTurnstileScriptPromise) {
			return window.__grubvisionTurnstileScriptPromise
		}

		const url = `https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit`
		window.__grubvisionTurnstileScriptPromise = new Promise((resolve, reject) => {
			const script = document.createElement("script")
			script.src = url
			script.async = true
			script.defer = true
			script.addEventListener("error", () => {
				console.error("Failed to load Cloudflare Turnstile script")
				window.__grubvisionTurnstileScriptPromise = null
				reject()
			})
			script.onload = resolve
			document.head.appendChild(script)
		})
		return window.__grubvisionTurnstileScriptPromise
	}

	function renderTurnstile() {
		if (!containerRef.value || !window.turnstile || widgetId !== null) return
		widgetId = window.turnstile.render(containerRef.value, {
			sitekey: props.siteKey,
			callback(token) {
				currentToken = token
				emits("token", token)
			},
			"error-callback"(error) {
				console.error("Turnstile challenge failed", error)
			},
			"expired-callback"() {
				currentToken = ""
				emits("token", "")
			},
		})
	}

	async function execute() {
		if (currentToken) return currentToken
		await loadScript()
		renderTurnstile()
		if (currentToken) return currentToken
		throw new Error("Please complete the Turnstile challenge.")
	}

	function reset() {
		currentToken = ""
		emits("token", "")
		if (widgetId !== null) {
			window.turnstile?.reset?.(widgetId)
		}
	}

	onMounted(() => {
		loadScript()
			.then(renderTurnstile)
			.catch(() => {})
	})

	onUnmounted(() => {
		if (widgetId !== null) {
			window.turnstile?.remove?.(widgetId)
		}
	})

	defineExpose({ execute, reset })
</script>
